import illegalInvocationFilter from './helpers/sentryIllegalInvocationFilter';

const filters = [illegalInvocationFilter];

export default () => {
  if (!window.app.sentry.enabled) {
    return;
  }

  import(/* webpackChunkName: "sentry" */ '@sentry/browser')
    .then((Sentry) => {
      Sentry.init({
        dsn: window.app.sentry.dsn,
        ignoreErrors: [
          'top.GLOBALS',
          'document.getElementsByClassName.ToString',
        ],
        ignoreUrls: [
          /graph\.facebook\.com/i,
          /connect\.facebook\.net\/en_US\/all\.js/i,
          /extensions\//i,
          /^chrome:\/\//i,
        ],

        // Returning null will discard the event
        beforeSend(event) {
          if (
            typeof event.exception === 'undefined'
            || typeof event.exception.values === 'undefined'
            || !event.exception.values.length
          ) {
            return event;
          }

          const [exception] = event.exception.values;

          // Loop over filters, a filter that returns false will
          // discard the event.
          for (let i = 0; i < filters.length; i += 1) {
            if (!filters[i](exception)) {
              return null;
            }
          }

          return event;
        },
      });

      window.app.sentry.loaded = true;

      if (window.capturedErrors.length) {
        window.capturedErrors.forEach((capturedError) => {
          Sentry.captureException(new Error(capturedError[0]), {
            extra: {
              file: capturedError[1],
              lineno: capturedError[2],
              colno: capturedError[3],
            },
          });
        });
      }
    });
};
